import { codeExecution } from './code-execution';
import { fileSearch } from './file-search';
import { mcpServer } from './mcp-server';
import { viewImage } from './view-image';
import { viewXVideo } from './view-x-video';
import { webSearch } from './web-search';
import { xSearch } from './x-search';

export {
  codeExecution,
  fileSearch,
  mcpServer,
  viewImage,
  viewXVideo,
  webSearch,
  xSearch,
};

export const xaiTools = {
  codeExecution,
  fileSearch,
  mcpServer,
  viewImage,
  viewXVideo,
  webSearch,
  xSearch,
};
